import type {ConnectElementConfig} from '../ConnectElementList';

export const treasuryReactivationOnboardingRequiredParameter =
  'onboarding-required' as const;

export const TreasuryReactivationConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "treasuryReactivation" */
      '../../../components/MoneyManagement/TreasuryReactivation/TreasuryReactivation'
    ),
  releaseState: 'internal',
  sentryTeam: 'platform_surfaces_embedded',
  teamOwner: 'platform-surfaces',
  htmlAttributes: {
    [treasuryReactivationOnboardingRequiredParameter]: {
      isInternal: true,
    },
  },
  htmlEvents: ['close'],
  customHtmlElementMethods: {
    setOnClose: {
      type: 'EventListenerMethod',
      event: 'close',
      isInternal: true,
      description: 'Called when the Treasury entry modal is closed.',
    },
    setOnboardingRequired: {
      type: 'AttributeSettingMethod',
      attribute: treasuryReactivationOnboardingRequiredParameter,
      isInternal: true,
      description:
        'Sets whether Treasury onboarding is required. The module is hidden otherwise.',
    },
  },
  description:
    'Module to prompt for needed step-up compliance actions or to promote a new feature.',
  friendlyName: 'Treasury Reactivation Module',
};
